<template>
  <div class="track-big-mg" style="border-bottom:1px #fff solid;">
    <div class="track-shadow2" style="margin-top: 25px ">
      <el-form :model="form" style="position: relative;">
        <el-row style="width:200px; ">
          <el-form-item style="margin-bottom: 0px;">
            <el-select
              class="track-input1"
              v-model="form.condition"
              placeholder="查询条件"
              @change="refresh"
            >
              <el-option v-for="(item,index) in portArry2" :key="index" :value="item.port"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <!-- 提单号查询 -->
        <el-row
          style="position: absolute;top: 0px;left: 200px;"
          :style="form.condition==='提单号查询'?'':'display: none;'"
        >
          <el-col :span="4" style="margin-left:10px;">
            <el-form-item style="margin-bottom: 0px;">
              <el-select class="track-input1" v-model="form.startPort" placeholder="请选择起运港">
                <el-option
                  v-for="(item,index) in portArry"
                  :key="index"
                  :label="item.port"
                  :value="item.portEN"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item style="margin-bottom: 0px;" class="cgs">
              <el-select
                class="track-input3"
                v-model="form.carryOdd"
                filterable
                clearable
                remote
                default-first-option
                placeholder="船公司"
                :remote-method="remoteStart"
                @focus="getNewFocus"
                @change="loadAlls"
              >
                <el-option
                  v-for="(item,index) in lading"
                  :key="index"
                  :label="item.alias"
                  :value="item.alias"
                  style="width: 200px;"
                >
                  <span style="float: left;font-size: 12px;">{{ item.alias }}</span>
                  <!-- <span
                    style="float: right;font-size: 12px;margin-left: 10px;"
                  >{{ item.short_name_cn }}</span>-->
                </el-option>
              </el-select>
            </el-form-item>
            <div
              :class="hidden1==0 ? 'ant-tooltip-hidden':''"
              class="ant-tooltip product-service-tooltip"
              style="left: 185px;top: 48px;transform-origin: 0px -4px;"
            >
              <div class="ant-tooltip-content">
                <div class="ant-tooltip-arrow"></div>
                <div class="ant-tooltip-inner">请输入船公司</div>
              </div>
            </div>
          </el-col>
          <el-col
            :span="8"
            class="track-input2 track-border"
            style="width: 440px; margin-left: 31px;"
          >
            <el-form-item style="margin-bottom: 0px; margin-left: 10px;">
              <el-input clearable placeholder="请输入提单号" v-model="form.billNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: 60px;">
            <el-form-item style="margin-bottom: 0px;">
              <el-button class="track-button" icon="el-icon-search" @click="Inquire">跟踪查询</el-button>
            </el-form-item>
            <div
              :class="hidden2==0 ? 'ant-tooltip-hidden':''"
              class="ant-tooltip product-service-tooltip"
              style="left: 395px;top:48px;transform-origin: 0px -4px;"
            >
              <div class="ant-tooltip-content">
                <div class="ant-tooltip-arrow"></div>
                <div class="ant-tooltip-inner">请输入提单号</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 订单号查询 -->
        <el-row
          style="position: absolute;top: 0px;left: 200px; "
          :style="form.condition==='订单号查询'?'':'display: none;'"
        >
          <el-col :span="16" class="track-input2 track-border" style="width: 813px;">
            <el-form-item style="margin-bottom: 0px;" ref="orderNumber">
              <el-input clearable placeholder="请输入订单号" v-model="orderNumber"></el-input>
            </el-form-item>
            <div
              :class="hidden3==0 ? 'ant-tooltip-hidden':''"
              class="ant-tooltip product-service-tooltip"
              style="left: 11px;top: 48px;transform-origin: 0px -4px;"
            >
              <div class="ant-tooltip-content">
                <div class="ant-tooltip-arrow"></div>
                <div class="ant-tooltip-inner" v-if="this.Check === 1">请输入订单号</div>
                <div class="ant-tooltip-inner" v-if="this.Check === 2">请输入正确订单号</div>
              </div>
            </div>
          </el-col>
          <el-col :span="4" style="margin-left: 20px;">
            <el-form-item style="margin-bottom: 0px;">
              <el-button class="track-button" icon="el-icon-search" @click="Inquire2">跟踪查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="history">
          <el-row v-if="this.historys == 1">
            <el-col :span="2" style="margin-left: 5px; width:61px;">
              <div class="grid-content bg-purple">历史查询:</div>
            </el-col>
            <el-col :span="22" style="width:1134px;">
              <li :span="3" v-for="(item,index) in HistoryForm" style="width:160.5px;float: left;">
                <el-tooltip placement="bottom" effect="dark">
                  <div class="history_item" @click="historyClick(item)">{{item.mblNo}}</div>
                  <div slot="content" style="height: 10px;line-height: 10px;">{{item.mblNo}}</div>
                </el-tooltip>
              </li>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <div class="track-shadow" style="padding: 30px;" v-loading="loading">
      <div v-show="status">
        <div class="track-border1">
          <div class="track-font track-tx-left track-font-weight">
            <span>提单号：{{trackListInfo.mblNo}}</span>
            <span
              style="margin-left: 20px"
            >状态更新时间：{{dataFormat(trackListInfo.lastModifyTime,'yyyy-MM-dd hh:mm')}}</span>
          </div>
          <div class="track-font12 track-tx-left" style="padding-top: 10px;">
            <el-row>
              <el-col :span="4">船公司：{{trackListInfo.carrierCode}}</el-col>
              <el-col :span="14">
                <el-row>
                  <el-col :span="2">
                    <div style="display: inline-block;">起运港：</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="og-HH">{{trackListInfo.polName}}</div>
                  </el-col>
                  <el-col :span="4">
                    <!-- <div class="track-tx-center">{{trackListInfo.vesselPlanStatus}}</div> -->
                    <div class="track-address-horizon"></div>
                    <!-- <div class="track-tx-center">4天</div> -->
                  </el-col>
                  <el-col :span="2">
                    <div>目的港：</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="og-HH">{{trackListInfo.podName}}</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <div>箱型/箱量：{{trackListInfo.ctnrCount}}</div>
                <div>船名/航次：{{trackListInfo.vesselNameEn}}/{{trackListInfo.voyage}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="track-border1">
          <div class="track-font-weight track-font track-tx-left" style="margin: 20px 0;">跟踪动态</div>
          <el-row>
            <el-col class="track-col">
              <div :class="trackListSTSP.statusCode?'track-empty-active':'track-empty'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListSTSP.statusCode?'track-color':'track-color2'"
              >已提空箱</div>
              <div
                v-if="trackListSTSP"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListSTSP.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListSTSP.ctnrStatusActual>0  && trackListSTSP.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListSTSP?'track-color':''">{{trackListSTSP.ctnrStatusActual}}</span>/
                <span>{{trackListSTSP.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListGITM.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListGITM.statusCode?'track-weight-active':'track-weight'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListGITM.statusCode?'track-color':'track-color2'"
              >重箱进港</div>
              <div v-if="trackListGITM" class="track-font12 track-tx-center track-color">
                {{dataFormat(trackListGITM.statusTime,'MM-dd hh:mm')}}
                <!-- <el-tooltip placement="right-start" :visible-arrow="false" effect="light">
                  <div slot="content">
                    节点时间
                    更新时间
                  </div>
                  <el-button type="text" style="padding:0px;">变</el-button>
                </el-tooltip>-->
              </div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListGITM.ctnrStatusActual>0  && trackListGITM.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListGITM?'track-color':''">{{trackListGITM.ctnrStatusActual}}</span>/
                <span>{{trackListGITM.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListPASS.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListPASS.statusCode?'track-customs-active':'track-customs'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListPASS.statusCode?'track-color':'track-color2'"
              >海关放行</div>
              <div
                v-if="trackListPASS"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListPASS.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListPASS.ctnrStatusActual>0  && trackListPASS.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListPASS?'track-color':''">{{trackListPASS.ctnrStatusActual}}</span>/
                <span>{{trackListPASS.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListTMPS.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListTMPS.statusCode?'track-wharf-active':'track-wharf'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListTMPS.statusCode?'track-color':'track-color2'"
              >码头放行</div>
              <div
                v-if="trackListTMPS"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListTMPS.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListTMPS.ctnrStatusActual>0  && trackListTMPS.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListTMPS?'track-color':''">{{trackListTMPS.ctnrStatusActual}}</span>/
                <span>{{trackListTMPS.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListLOBD.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListLOBD.statusCode?'track-stowage-active':'track-stowage'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListLOBD.statusCode?'track-color':'track-color2'"
              >航司配载</div>
              <div
                v-if="trackListLOBD"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListLOBD.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListLOBD.ctnrStatusActual>0  && trackListLOBD.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListLOBD?'track-color':''">{{trackListLOBD.ctnrStatusActual}}</span>/
                <span>{{trackListLOBD.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListDLPT.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListDLPT.statusCode?'track-departure-active':'track-departure'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListDLPT.statusCode?'track-color':'track-color2'"
              >船舶离港</div>
              <div
                v-if="trackListDLPT"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListDLPT.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListDLPT.ctnrStatusActual>0  && trackListDLPT.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListDLPT?'track-color':''">{{trackListDLPT.ctnrStatusActual}}</span>/
                <span>{{trackListDLPT.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListBDAR.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListBDAR.statusCode?'track-arrived-active':'track-arrived'"></div>
              <div
                class="track-font12 track-margin-top track-tx-center"
                :class="trackListBDAR.statusCode?'track-color':'track-color2'"
              >船舶抵港</div>
              <div
                v-if="trackListBDAR"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListBDAR.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListBDAR.ctnrStatusActual>0  && trackListBDAR.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListBDAR?'track-color':''">{{trackListBDAR.ctnrStatusActual}}</span>/
                <span>{{trackListBDAR.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListSTCS.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListSTCS.statusCode?'track-leave-active':'track-leave'"></div>
              <div
                class="track-font12 track-margin-top"
                :class="trackListSTCS.statusCode?'track-color':'track-color2'"
              >重箱离港</div>
              <div
                v-if="trackListSTCS"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListSTCS.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListSTCS.ctnrStatusActual>0  && trackListSTCS.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListSTCS?'track-color':''">{{trackListSTCS.ctnrStatusActual}}</span>/
                <span>{{trackListSTCS.ctnrStatusAmount}}</span>
              </div>
            </el-col>
            <el-col class="track-col1">
              <div :class="trackListRCVE.statusCode?'track-arrow-active':'track-arrow'"></div>
            </el-col>
            <el-col class="track-col">
              <div :class="trackListRCVE.statusCode?'track-again-active':'track-again'"></div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                :class="trackListRCVE.statusCode?'track-color':'track-color2'"
              >空箱还场</div>
              <div
                v-if="trackListRCVE"
                class="track-font12 track-tx-center track-color"
              >{{dataFormat(trackListRCVE.statusTime,'MM-dd hh:mm')}}</div>
              <div
                class="track-font12 track-tx-center track-margin-top"
                v-show="trackListRCVE.ctnrStatusActual>0  && trackListRCVE.ctnrStatusAmount>0 "
              >
                箱数量：
                <span :class="trackListRCVE?'track-color':''">{{trackListRCVE.ctnrStatusActual}}</span>/
                <span>{{trackListRCVE.ctnrStatusAmount}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class>
          <div class="track-font-weight track-font track-tx-left" style="margin: 20px 0;">船舶计划</div>
          <el-row :gutter="5">
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">船名</div>
              <div
                class="track-font12 track-tx-left track-margin-top"
              >{{trackListPlan.vesselNameEn}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">航次(进口/出口)</div>
              <div class="track-font12 track-tx-left track-margin-top">
                <div class="sp_access">{{trackListPlan.importVoyage}}</div>
                <span
                  style=" margin: 0 10px;"
                  v-if="trackListPlan.exportVoyage || trackListPlan.importVoyage"
                >/</span>
                <div class="sp_access">{{trackListPlan.exportVoyage}}</div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">开港时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.cyOpenTime}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">截港时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.cyCloseTime}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">计划靠泊时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.eta}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">计划离泊时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.etd}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">实际靠泊时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.ata}}</div>
            </el-col>
            <el-col :span="3">
              <div class="track-font12 track-tx-left track-font-weight">实际离泊时间</div>
              <div class="track-font12 track-tx-left track-margin-top">{{trackListPlan.atd}}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-show="!status">
        <div class="track-no-padding">
          <div class="track-no-data"></div>
          <div class="track-no-font" v-if="form.condition==='提单号查询'">暂未查询到提单相关信息，请稍后重试</div>
          <div class="track-no-font" v-if="form.condition==='订单号查询'">暂未查询到订单相关信息，请稍后重试</div>
        </div>
      </div>
    </div>
    <!-- <div class="track-shadow" style="padding: 30px;margin-top: 20px;" v-loading="loading">
      <div v-show="status"></div>
      <div v-show="!status">
        <div class="track-no-padding">
          <div class="track-no-data"></div>
          <div class="track-no-font">暂未查询到船公司相关信息，请稍后重试</div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
// import axios from "axios";
export default {
  data() {
    return {
      historys: "0",
      tr: 1,
      hidden1: "0", //船公司校验
      hidden2: "0", //提单号校验
      hidden3: "0", //订单号校验
      loading: false,
      form: {
        billNo: "", //提单号
        startPort: "", //起运港
        carryOdd: "", //船公司
        condition: "" //查询条件
      },
      Check: 0, //订单号校验参数
      orderNumber: "", //订单号
      Shipment: 40, //跟踪必传参数（写死）
      portArry: [
        //起运港数组
        { port: "上海港", portEN: "CNSHA", portCN: "SHANGHAI" },
        { port: "宁波港", portEN: "CNNGB", portCN: "NINGBO" },
        { port: "深圳港", portEN: "CNSZX", portCN: "SHENZHEN" },
        { port: "广州港", portEN: "CNCAN", portCN: "XIAMEN" },
        { port: "青岛港", portEN: "CNTAO", portCN: "QINGDAO" },
        { port: "天津港", portEN: "CNTNJ", portCN: "TIANJIN" },
        { port: "大连港", portEN: "CNDLC", portCN: "DALIAN" }
      ],
      portArry2: [
        //查询条件
        { port: "提单号查询" },
        { port: "订单号查询" }
      ],
      lading: [],
      trackList: {
        statuscd: {}
      },
      trackListInfo: {},
      trackListPlan: {},
      trackListStatus: [],
      trackListSTSP: {},
      trackListGITM: {},
      trackListPASS: {},
      trackListTMPS: {},
      trackListLOBD: {},
      trackListDLPT: {},
      trackListBDAR: {},
      trackListSTCS: {},
      trackListRCVE: {},
      HistoryForm: [],
      status: false //标记是否有数据
    };
  },
  mounted: function() {
    this.form.startPort = this.portArry[0].portEN; //默认选中上海港
    this.form.condition = this.portArry2[0].port; //默认选中订单号
    this.history();
  },
  methods: {
    loadAlls(value) {
      this.form.carryOdd = value;
    },
    getNewFocus() {
      this.loadAll(this.form.carryOdd);
    },
    remoteStart(value) {
      this.loadAll(value);
    },
    //船公司数据
    async loadAll(value) {
      let that = this;
      let params = {};
      params.custInfo = value;
      let response = await that.apiService
        .get("/sinoslog-common-service/csCust/queryCustAlias", {
          params
        })
        .then(res => {
          this.lading = res.data.data;
        });
    },
    //返回船公司
    // shipping() {
    //   let that = this;
    //   that
    //     .axios({
    //       method: "get",
    //       url:
    //         that.apiUrl +
    //         "/bnwl_base_business/billNoRules/getShippingCompanyCode",
    //       timeout: 60000,
    //       responseType: "json",
    //       params: {
    //         billNo: that.form.billNo
    //       }
    //     })
    //     .then(res => {
    //       that.lading = res.data.billNoRulesVoList;

    //       if (that.lading.length == 1) {
    //         if (that.lading[0].shortNameEn) {
    //           that.form.carryOdd = res.data.billNoRulesVoList[0].shortNameEn;
    //         }
    //       } else {
    //         that.form.carryOdd = "";
    //       }
    //     });
    // },
    //跟踪查询校验
    Inquire() {
      let that = this;
      let cg = that.form.carryOdd;
      let dt = that.form.billNo;
      if (!cg && !dt) {
        that.hidden1 = 1;
        that.hidden2 = 1;
        setTimeout(function() {
          that.hidden1 = "0";
          that.hidden2 = "0";
        }, 3000);
        return false;
      } else if (cg && !dt) {
        that.hidden1 = 0;
        that.hidden2 = 1;
        setTimeout(function() {
          that.hidden2 = "0";
        }, 3000);
        return false;
      } else if (!cg && dt) {
        that.hidden1 = 1;
        that.hidden2 = 0;
        setTimeout(function() {
          that.hidden1 = "0";
        }, 3000);
        return false;
      } else {
        this.loading = true;
        // this.trackQuery();
        this.astrict("TDGZ");
      }
    },
    Inquire2() {
      let that = this;
      var regPassword = /^T[0-9]\d{12}$/;
      var orderNumberss = this.orderNumber;
      if (this.orderNumber.length === 0) {
        this.Check = 1;
        this.hidden3 = 1;
        setTimeout(function() {
          that.hidden3 = "0";
        }, 3000);
        return false;
      } else if (regPassword.test(orderNumberss)) {
        this.Check = 0;
        this.astrict("DDGZ");
        this.loading = true;
        return false;
      } else {
        this.Check = 2;
        this.hidden3 = 1;
        setTimeout(function() {
          that.hidden3 = "0";
        }, 3000);
        return false;
      }
    },
    //限制查询
    async astrict(e) {
      let that = this;
      if (e == "TDGZ") {
        var w = that.form.billNo;
        var s = that.form.startPort;
        var o = that.form.carryOdd;
      } else {
        var r = that.orderNumber;
      }
      var getfo = JSON.parse(localStorage.getItem("userInfo"));
      let data = {};
      data.opsUserId = getfo.opsUserId;
      w;
      data.mblNo = w;
      data.polCode = s;
      data.carrierCode = o;
      let response = await this.apiService
        .post("/sinoslog-ops-service/salesLeads/userRestrictions", data)
        .then(res => {
          if (res.status == 200) {
            if (res.data.data == true) {
              if (e == "TDGZ") {
                this.trackQuery();
              } else if (e == "DDGZ") {
                this.trackQuery2();
              }
            } else {
              this.loading = false;
              this.$alert("您今天5次查询额度已用完，请明天再查询", "查询提示", {
                customClass: "astrict_pop",
                confirmButtonText: "确定"
              });
            }
          }
        });
    },
    // 销售线索
    async clue(e) {
      let that = this;
      var getfo = JSON.parse(localStorage.getItem("userInfo"));
      let data = {};
      data.salesLeadsType = "TB";
      data.opsCustId = getfo.opsCustId;
      data.opsUserId = getfo.opsUserId;
      data.userDomainCode = "SSLCP";
      data.salesLeadsTruck = {};
      data.salesLeadsTruck.carrierNameEn = e.carrierCode;
      data.salesLeadsTruck.carrierCode = that.form.carryOdd;
      data.salesLeadsTruck.mblNo = that.form.billNo;
      data.salesLeadsTruck.polName = e.polName;
      data.salesLeadsTruck.polCode = that.form.startPort;
      data.salesLeadsTruck.podName = e.podName;
      data.salesLeadsTruck.podCode = e.podCode;
      data.salesLeadsTruck.polEtd = e.polEtd;
      data.salesLeadsTruck.ctnrCount = e.ctnrCount;
      data.salesLeadsTruck.vesselNameEn = e.vesselNameEn;
      data.salesLeadsTruck.vesselNameCn = "";
      data.salesLeadsTruck.exportVoyage = e.voyage;
      data.salesLeadsTruck.isTransit = e.isTransit;
      await that.apiService
        .post("/sinoslog-ops-service/salesLeads/salesLeadsRecord", data)
        .then(res => {});
    },
    //提单跟踪查询.
    async trackQuery(e) {
      this.loading = true;
      let self = this;
      let data = {};
      data.referenceno = self.form.billNo;
      data.polCode = self.form.startPort;
      data.carriercd = self.form.carryOdd;
      await self.apiService
        .post(
          "/sinoslog-ops-service/sailingDate/uploadAndDownloadBooking",
          data
        )
        .then(res => {
          this.clue(res.data.data);
          self.loading = false;
          self.trackListStatus = {};
          self.trackListPlan = {};
          if (res.data.data.data) {
            self.status = true;
            self.trackListInfo = res.data.data.data.traceBookingBlInfo;
            if (res.data.data.data.traceBookingBlStatuses) {
              self.trackListStatus = res.data.data.data.traceBookingBlStatuses;
              for (let i in self.trackListStatus) {
                if (self.trackListStatus[i].statusCode === "STSP") {
                  self.trackListSTSP = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "GITM") {
                  self.trackListGITM = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "PASS") {
                  self.trackListPASS = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "TMPS") {
                  self.trackListTMPS = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "LOBD") {
                  self.trackListLOBD = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "DLPT") {
                  self.trackListDLPT = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "BDAR") {
                  self.trackListBDAR = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "STCS") {
                  self.trackListSTCS = self.trackListStatus[i];
                } else if (self.trackListStatus[i].statusCode === "RCVE") {
                  self.trackListRCVE = self.trackListStatus[i];
                }
              }
            }
            if (res.data.data.data.traceBookingVesselPlan) {
              self.trackListPlan = res.data.data.data.traceBookingVesselPlan;
            }
          } else {
            self.status = false;
            if (this.tr < 3) {
              this.tr++;
              this.trackQuery();
            } else {
              this.tr = 0;
              return false;
            }
          }
          if (e == 1) {
            return false;
          } else {
            // this.Shipmentquery();
          }
        });
    },
    //订单跟踪查询
    trackQuery2() {
      var self = this;
      self
        .axios({
          method: "get",
          url: self.apiUrl + "/bnwl_oms_business/api/logistics-tracing-orderNo",
          timeout: 60000,
          responseType: "json",
          params: {
            orderNo: self.orderNumber
          }
        })
        .then(res => {
          this.loading = false;
          // console.log(res.data.message);
          if (res.data.message == "成功") {
            this.$router.push({
              name: "OrderTwo",
              params: {
                orderNo: self.orderNumber
              }
            });
          } else if (res.data.message == "查询365没有匹配到跟踪数据") {
            return false;
          } else if (res.data.message == "该订单号没有匹配到跟踪数据") {
            return false;
          }
        });
    },
    /**
     * 格式化日期,特殊定制化的格式化
     **/
    dataFormat(date, format) {
      // 兼容IE
      var time;
      if (!date) return "";
      if (typeof date === "string") {
        time = new Date(
          date
            .replace(/-/g, "/")
            .replace(/T|Z/g, " ")
            .trim()
        );
      } else if (typeof date === "object") {
        time = new Date(date);
      }
      var o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (time.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    },
    Shipmentquery() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      let that = this;
      var tot = "";
      var arr = this.portArry;
      for (var i = 0; i < arr.length; i++) {
        if (that.form.startPort == arr[i].portEN) {
          tot = arr[i].portCN;
        }
      }
      that
        .axios({
          method: "post",
          url: that.apiUrl + "/bnwl_oms_business/enquiry/enquirySend",
          timeout: 60000,
          responseType: "json",
          data: {
            clewType: that.Shipment,
            userNameCode: JSON.parse(localStorage.getItem("userInfo")).username,
            billNo: that.form.billNo,
            shippingCompany: that.form.carryOdd,
            originPort: tot,
            originPortCode: that.form.startPort
          }
        })
        .then(res => {
          // console.log(res);
        });
    },

    refresh() {
      this.status = false;
    },
    // 获取历史记录
    async history() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      var that = this;
      let params = {};
      params.opsUserId = len.opsUserId;
      params.salesLeadsType = "TB";
      let response = await this.apiService
        .get("/sinoslog-ops-service/salesLeads/userSearchHistory", {
          params
        })
        .then(res => {
          if (res.data.data) {
            if (res.data.data.length) {
              this.historys = 1;
              this.HistoryForm = res.data.data;
            } else {
              this.historys = 0;
              return false;
            }
          } else {
            this.historys = 0;
            return false;
          }
        });
    },
    //历史记录点击
    historyClick(e) {
      if (this.form.condition == "提单号查询") {
        this.form.billNo = e.mblNo;
        this.form.carryOdd = e.carrierCode;
        this.form.startPort = e.polCode;
        this.trackQuery("1");
        this.loading = true;
      } else if (this.form.condition == "订单号查询") {
        this.orderNumber = e.billNo;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.track-address-horizon {
  background: url("../assets/img/add-horizon.png") no-repeat center;
  height: 10px;
  width: 100%;
  padding-top: 10px;
}
/**箭头**/
.track-arrow {
  background: url("../assets/img/track-arrow.png") no-repeat;
  background-size: contain;
  height: 8px;
  width: 100%;
  margin: 20px 0;
}
.track-arrow-active {
  background: url("../assets/img/track-arrow-active.png") no-repeat;
  background-size: contain;
  height: 8px;
  width: 100%;
  margin: 20px 0;
}

/**已提空箱**/
.track-empty-active {
  background: url("../assets/img/empty-active-icon.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-empty {
  background: url("../assets/img/empty-icon.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**重箱进港**/
.track-weight-active {
  background: url("../assets/img/weight-active-icon.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-weight {
  background: url("../assets/img/weight-icon.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**海关放行**/
.track-customs-active {
  background: url("../assets/img/track-customs-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-customs {
  background: url("../assets/img/track-customs.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**码头放行**/
.track-wharf-active {
  background: url("../assets/img/wharf-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-wharf {
  background: url("../assets/img/wharf.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**航司配载**/
.track-stowage-active {
  background: url("../assets/img/stowage-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-stowage {
  background: url("../assets/img/stowage.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**船舶离港**/
.track-departure-active {
  background: url("../assets/img/departure-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-departure {
  background: url("../assets/img/departure.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**船舶抵港**/
.track-arrived-active {
  background: url("../assets/img/arrived-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-arrived {
  background: url("../assets/img/arrived.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**重箱离港**/
.track-leave-active {
  background: url("../assets/img/leave-port-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-leave {
  background: url("../assets/img/leave-port.png") no-repeat center;
  width: 100%;
  height: 48px;
}
/**空箱还场**/
.track-again-active {
  background: url("../assets/img/put-box-active.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-again {
  background: url("../assets/img/put-box.png") no-repeat center;
  width: 100%;
  height: 48px;
}
.track-input1 {
  width: 100%;
}
.track-input3 {
  margin-left: 10px;
}
.track-input3 input {
  line-height: 1.4;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 45px;
  width: 200px;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea !important;
}
.track-input1 input {
  line-height: 1.4;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 45px;
  width: 100%;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}
.track-input2 input {
  margin-left: 10px;
  line-height: 1.4;
  border-color: #fff;
  border-radius: 0;
  height: 45px;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}
.track-button {
  float: right !important;
  width: 180px !important;
  border-color: #fff;
  border-radius: 0;
  height: 45px;
  box-shadow: 0px 1px 3px #888888;
  background-color: #fff;
  border: 1px solid #eaeaea;
}
.track-padding {
  padding: 0 15px;
}
.track-border {
  border-left: 1px solid #ddd;
}
.track-border1 {
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;
}
.track-font {
  font-size: 14px;
}
.track-font12 {
  font-size: 12px;
}
.track-font-weight {
  font-weight: bold;
}
.track-tx-left {
  text-align: left;
}
.track-tx-center {
  text-align: center;
}
.track-shadow {
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}
.track-col.el-col {
  width: 7.777777%;
}
.track-col1.el-col {
  width: 3.75%;
}
.track-margin-top {
  margin-top: 10px;
}
.track-color {
  color: #3bc4a3;
}
.track-color2 {
  color: #bfbfbf;
}
.track-no-data {
  background: url("../assets/img/no-data.png") no-repeat center;
  width: 100%;
  height: 116px;
}
.track-no-font {
  font-family: "SourceHanSans-Regular";
  color: #999999;
  font-size: 16px;
}
.track-no-padding {
  padding: 80px 100px 140px 100px;
}
.track-big-mg {
  margin: 0 8% 30px 11%;
  width: 1200px;
  margin: 0 auto;
}
.cgs > .el-form-item__content > .el-form-item__error {
  left: 12px !important;
}
.track-button:hover {
  background: #66b1ff !important;
  border-color: #66b1ff !important;
  color: #fff !important;
}
.astrict_pop > .el-message-box__header > .el-message-box__title {
  color: #02438f;
  font-size: 16px;
  font-weight: 700;
}
.astrict_pop > .el-message-box__content > .el-message-box__message {
  color: #000;
  font-family: "SourceHanSans-Regular";
}
.astrict_pop > .el-message-box__btns > .el-button--primary {
  background: #00418e;
}
</style>



// WEBPACK FOOTER //
// src/views/OgisticsTrack.vue